import { createContext } from 'react';
import { Model } from '@lucidtech/las-sdk-browser';

export type ModelContextValue = Model;

export const ModelContext = createContext<ModelContextValue | undefined>(undefined);
